import { defineMessages } from '@jutro/locale';

export default defineMessages({
    MLClaimReservesHeader: {
        id: 'ml.gateway.views.AccountClaims.MLClaimReserves.Reserves - Internal Use Only',
        defaultMessage: 'Reserves - Internal Use Only'
    },
    coverage: {
        id: 'ml.gateway.views.AccountClaims.MLClaimReserves.Coverage',
        defaultMessage: 'Coverage'
    },
    reserveAmount: {
        id: 'ml.gateway.views.AccountClaims.MLClaimReserves.Reserve Amount',
        defaultMessage: 'Reserve Amount'
    },
    amountPaidToDate: {
        id: 'ml.gateway.views.AccountClaims.MLClaimReserves.Amount Paid To Date',
        defaultMessage: 'Amount Paid To Date'
    }

});
